import router from './router'
import store from './store'
// import 'nprogress/nprogress.css' // progress bar style
import {getToken, removeToken} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/find-password','/WorkSheet/Index/1'] // no redirect whitelist

// router.beforeEach(async(to, from, next) => {
//     // start progress bar
//     // NProgress.start() 

//     // set page title
//     document.title = getPageTitle(to.meta.title)
//     const {username, password} = JSON.parse(localStorage.getItem('loginInfo')) ?? {};
//     var un,ps;
//     un=username;
//     ps=password;
//     // determine whether the user has logged in
//     var hasToken = getToken();

//     var toPath = to.path;
//     var quer = to.query;
//     // console.log('abc',toPath,quer,hasToken)
//     if (toPath.startsWith('/WorkSheet/SheetViewParent/') && quer.token ){
//         // console.log('a1')
//         var dataid = toPath.replace('/WorkSheet/SheetViewParent/','')
//         var token = dataid + '_' + quer.token
//         // console.log(dataid,quer.token)
//         // var aa = await store.dispatch('user/quickLogin', {token:quer.token,toPath})
//         var aa = await store.dispatch('user/quickLogin', {token,toPath})
//         // console.log('aa',aa, store.state.user)
//             localStorage.setItem('loginInfo', JSON.stringify({
//               password:store.state.user.password,
//               username:store.state.user.userName,
//               userId: store.state.user.userId
//             }));
//         hasToken = getToken();
//         un=store.state.user.userName;
//         ps=store.state.user.password;
//         await store.dispatch('user/getUserMenu');
//         // console.log('hasToken',hasToken,un,ps)
//     }
    
//     if (hasToken && un && ps) {
//         if (to.path === '/login') {
//             // if is logged in, redirect to the home page
//             next({path: '/'})
//             // NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
//         } else {

//             try {
//                 // console.log('do',store.state.user,store.state.user.slideData)
//                 // get user info
//                 // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
//                 await store.dispatch('user/getUserCompany', {un, ps});
//                 if (!store.state.user?.slideData?.length) {
//                     // console.log('jinru11111',un,ps)
//                     await store.dispatch('user/login', {username:un, password:ps});
//                     // console.log('do2',store.state.user.slideData)
//                     await store.dispatch('user/getUserMenu');
//                     // console.log('do3',store.state.user.slideData)
//                 }
//                 // console.log('do next'),
//                 // hack method to ensure that addRoutes is complete
//                 // set the replace: true, so the navigation will not leave a history record
//                 next()
//             } catch (error) {
//                 removeToken();
//                 next(`/login`)
//                 // NProgress.done()
//             }
//         }
//     } else {
//         /* has no token*/

//         if (whiteList.indexOf(to.path) !== -1) {
//             // in the free login whitelist, go directly
//             next()
//         } else {
//             // other pages that do not have permission to access are redirected to the login page.
//             next(`/login`)
//             // NProgress.done()
//         }
//     }
// })


router.beforeEach(async(to, from, next) => {
    // set page title
    document.title = getPageTitle(to.meta.title)
    const {username, password} = JSON.parse(localStorage.getItem('loginInfo')) ?? {};
    var un,ps;
    un=username;
    ps=password;
    // determine whether the user has logged in
    var hasToken = getToken();

    var toPath = to.path;
    var quer = to.query;
    var isSimple = false
    // console.log('abc',toPath,quer,hasToken)
    if (toPath.startsWith('/WorkSheet/SheetViewParent/') && quer.token ){
        // console.log('a1')

        var dataid = toPath.replace('/WorkSheet/SheetViewParent/','')
        var token = dataid + '_' + quer.token
        // console.log(dataid,quer.token)
        // var aa = await store.dispatch('user/quickLogin', {token:quer.token,toPath})

        // localStorage.removeItem('loginInfo');
        // removeToken();

        var aa = await store.dispatch('user/quickLogin2024', {token,toPath})
            //  localStorage.setItem('loginInfo', JSON.stringify({
            //   password:store.state.user.password,
            //   username:store.state.user.userName,
            //   userId: store.state.user.userId
            // }));
        
        // hasToken = getToken();
        isSimple = true
        // un=store.state.user.userName;
        // ps=store.state.user.password;
        // await store.dispatch('user/getUserMenu');
        // // console.log('hasToken',hasToken,un,ps)
    }
    if (isSimple){
        // console.log('isSimple')
        next()
    }else{
        if (hasToken && un && ps) {
            if (to.path === '/login') {
                // if is logged in, redirect to the home page
                next({path: '/'})
                // NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
            } else {

                try {
                    // console.log('do',store.state.user,store.state.user.slideData)
                    // get user info
                    // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
                    await store.dispatch('user/getUserCompany', {un, ps});
                    if (!store.state.user?.slideData?.length) {
                        // console.log('jinru11111',un,ps)
                        await store.dispatch('user/login', {username:un, password:ps});
                        // console.log('do2',store.state.user.slideData)
                        await store.dispatch('user/getUserMenu');
                        // console.log('do3',store.state.user.slideData)
                    }
                    // console.log('do next'),
                    // hack method to ensure that addRoutes is complete
                    // set the replace: true, so the navigation will not leave a history record
                    next()
                } catch (error) {
                    removeToken();
                    next(`/login`)
                    // NProgress.done()
                }
            }
        } else {
            /* has no token*/

            if (whiteList.indexOf(to.path) !== -1) {
                // in the free login whitelist, go directly
                next()
            } else {
                // other pages that do not have permission to access are redirected to the login page.
                next(`/login`)
                // NProgress.done()
            }
        }
    }
})

// router.afterEach(() => {
//     // finish progress bar
//     NProgress.done()
// })